module.exports = __webpack_public_path__ + "img/ic_twitter.184ccd01.svg";